import { GEOSERVER_WMS } from '../config';
import { isProdHost } from '../helpers';
import { EMapArea, EProtectedZone } from '../../types';

/**/
export const LAYERS = {
  [EMapArea.DEPTH_CURVES_BW]: {
    URL: GEOSERVER_WMS,
    NAME: isProdHost()
      ? 'zones:gebco_2024_contours'
      : 'zones:gebco_2021_contours_test',
    CLASSNAME: 'DepthCurvesBWLayer'
  },
  [EMapArea.DEPTH_CURVES_COLOUR]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:ColoredContoursLinesValues',
    CLASSNAME: 'DepthCurvesColourLayer'
  },
  [EMapArea.EEZ_AREAS]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:eez_v12',
    CLASSNAME: 'EEZAreaLayer'
  },
  [EMapArea.EEZ_LINES]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:eez_v12',
    STYLES: isProdHost() ? 'zones:eez-lines-only' : 'zones:eez-lines-only-test',
    CLASSNAME: 'EEZLinesLayer'
  },
  [EMapArea.EEZ_LINES_ALT]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:eez_v12',
    STYLES: isProdHost()
      ? 'zones:eez-lines-only-alt'
      : 'zones:eez-lines-only-alt-test',
    CLASSNAME: 'EEZLinesAltLayer'
  },
  [EMapArea.ICES]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:ices_areas',
    CLASSNAME: 'ICESLayer',
    STYLES: isProdHost() ? 'zones:ices-polygon_v2' : 'zones:ices-polygon-test'
  },
  [EMapArea.OSM]: {
    URL: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    NAME: 'osm',
    CLASSNAME: 'OSMLayer'
  },
  [EMapArea.SEABED_BW]: {
    URL: 'https://wms.gebco.net/mapserv?',
    NAME: 'gebco_latest',
    CLASSNAME: 'SeabedBWLayer'
  },
  [EMapArea.SEABED_COLOUR]: {
    URL: 'https://wms.gebco.net/mapserv?',
    NAME: 'gebco_latest',
    CLASSNAME: 'SeabedColourLayer'
  },
  ENVIRONMENT: {
    CLASS_NAME: 'EnvironmentLayer'
  },
  [EProtectedZone.MCZ]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:uk-protected-zones-mcz',
    CLASSNAME: 'ProtectedAreaLayer',
    ...(!isProdHost() && { STYLES: 'zones:uk-protected-zones-mcz-test' })
  },
  [EProtectedZone.SAC]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:uk-protected-zones-sac',
    CLASSNAME: 'ProtectedAreaLayer',
    ...(!isProdHost() && { STYLES: 'zones:uk-protected-zones-sac-test' })
  },
  [EProtectedZone.SPA]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:uk-protected-zones-spa',
    CLASSNAME: 'ProtectedAreaLayer',
    ...(!isProdHost() && { STYLES: 'zones:uk-protected-zones-spa-test' })
  },
  [EProtectedZone.NO_FJORD_LINES]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:no_fjord_coastal_cod',
    CLASSNAME: 'ProtectedAreaLayer'
  },
  [EProtectedZone.NO_PROTECTED_TCA]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:no_pa_closed_areas',
    CLASSNAME: 'ProtectedAreaLayer'
  },
  [EProtectedZone.NO_PROTECTED_CCR]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:no_pa_coral_reefs',
    CLASSNAME: 'ProtectedAreaLayer'
  },
  [EProtectedZone.NO_PROTECTED_CCNG]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:no_pa_cod_growing_areas',
    CLASSNAME: 'ProtectedAreaLayer'
  },
  [EProtectedZone.NO_PROTECTED_PZS]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:no_pa_forbidden_fishing_zones',
    CLASSNAME: 'ProtectedAreaLayer'
  },
  [EProtectedZone.NO_SEISMIC_ONGOING]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:no_pa_seismic_surveys_ongoing',
    CLASSNAME: 'ProtectedAreaLayer'
  },
  [EProtectedZone.NO_SEISMIC_PLANNED]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:no_pa_seismic_surveys_planned',
    CLASSNAME: 'ProtectedAreaLayer'
  },
  [EProtectedZone.SCOTTISH_MPA]: {
    URL: GEOSERVER_WMS,
    NAME: 'zones:scotland_mpa',
    CLASSNAME: 'ProtectedAreaLayer',
    STYLES: isProdHost() ? 'zones:scotland_mpa_prod' : 'zones:scotland_mpa_test'
  }
};
